import { jsx as _jsx } from "react/jsx-runtime";
import { Copy } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from '../styles/Superscript.styles';
import { useConfigurationByVariant } from '../SpecialOffersContext';
import { useSuperscriptContext } from '../SuperscriptContext';
const config = {
    variant1: {
        superscriptVariant: 'underline',
        color: 'typographyDefault',
    },
    variant2: {
        superscriptVariant: 'default',
        color: 'blue',
    },
};
const StyledCopy = themeStyles.apply(Copy, 'Superscript');
const Superscript = ({ label, ...styles }) => {
    const { superscriptVariant: variant, color } = useConfigurationByVariant(config);
    const handleOnClick = useSuperscriptContext();
    return (_jsx(StyledCopy, { size: "legal", as: "sup", color: color, ...styles, variant: variant, onClick: handleOnClick, children: label }));
};
export default Superscript;
